<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Organismos Nocivos</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDataType">Tipo de Organismo Nocivo</label>

                                    <ng-select [items]="listTiposOrganismoNocivo"
                                               bindLabel="Descripcion"
                                               bindValue="Codigo"
                                               formControlName="DataType"
                                               loadingText="Cargando..."
                                               [loading]="!(listTiposOrganismoNocivo)"
                                               notFoundText="Organismo Nocivo no encontrado"
                                               placeholder="-- Seleccione un tipo de Organismo Nocivo --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('DataType')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="Code">Código EPPO</label>
                                    <input formControlName="Code" name="Code" class="form-control" id="Code" type="text" value="" maxlength="255">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="CodeId">Código Numérico</label>
                                    <input formControlName="CodeId" name="CodeId" class="form-control" id="CodeId" value="" maxlength="255" type="number">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="FullName">Nombre completo</label>
                                    <input formControlName="FullName" name="FullName" class="form-control" id="FullName" type="text" value="" maxlength="255">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="Preferred">Favorito</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Preferred"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="RegulatedUe">Regulado por la UE</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="RegulatedUe"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                            </div>
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="NoEspecie">No Especie</label>
                                <p-selectButton class="selectButtonCust"
                                                [options]="listSiNoTodos"
                                                formControlName="NoEspecie"
                                                unselectable="true">
                                </p-selectButton>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                [disabled]="disableSearchBtn" title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                                [disabled]="formIsUntouched()"
                                                title="Limpia los filtros" (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
